import React, { Component, Fragment } from 'react';
import Modal from "react-responsive-modal";
import moment from 'moment';
import {UtilityService,SampleServices} from "../../services";
class Audit extends Component {
    state={
        openModal:false,
        data:''
    }
    
    getData(){
        if(this.props.moduleName !== undefined){
            SampleServices.auditForSample(this.props._id,this.props.moduleName.replace(/ /g,'').toLowerCase()).then((response)=>
            {
                if(response.status == 200) 
                    this.setState({data:response.text.data,openModal:true})
                
            }).catch(error => {
            
                UtilityService.errorMsg(this.msg);
            });
        }
        else{
            UtilityService.getAuditInfo(this.props._id).then((response)=>
            {
                if (response.status == 200) 
                    this.setState({data:response.text.data,openModal:true})
                
            }).catch(error => {
               
                UtilityService.errorMsg(this.msg);
              });
        }
       

          
    }
    render() {
        let {data} = this.state;
        
        return (
            <Fragment>
            
            {this.props.moduleName ==="Costing"?
            <button style={{cursor:"pointer"}} className={"primary pull-right px-2 py-1 mr-3"} onClick={(e)=> this.getData()}>
                <i className="material-icons" style={this.props.fontSize ? {fontSize:"14px"} : {fontSize:"20px"}}>
                card_travel
                </i>
            </button> 
            :
            <span style={{cursor:"pointer"}} className={(this.props.locationInfo !== undefined && this.props.locationInfo.pathname === "/developmentFabric") ? "btn-green-icon mr-3" : "btn-green-icon mr-3 pull-right py-1"} onClick={(e)=> this.getData()}>
                <i className="material-icons" style={this.props.fontSize ? {fontSize:"14px"} : {fontSize:"20px"}}>
                card_travel
                </i>
            </span>}
            <Modal
                open={this.state.openModal}
                onClose={() => this.setState({ openModal: false })}
                center
            >
            <table className="table table-bordered">
                <thead className={data !== null && data.modified !== null && data.modified !== undefined && data.modified.length > 0 ? 'd-contents' : 'd-none' }>
                    <tr>
                        <th scope="col">S.No</th>
                        {this.props._id === "bulkImport" && <th scope="col">Range</th> }
                        <th scope="col">{this.props._id === "bulkImport" ? "Generated By" : "Modified By"}</th>
                        {this.props._id === "bulkImport" && <th scope="col">Count</th> }
                        <th scope="col">Date</th>
                    </tr>
                </thead>
                <tbody>
                    { data !== null && data.modified !== null && data.modified !== undefined && data.modified.length > 0 && Array.isArray(data.modified) && data.modified.map((info,i)=>
                        <tr>
                            <th scope="row">{i+1}</th>
                            {this.props._id === "bulkImport" && <td>{info.data.from +" - "+ info.data.to}</td> }
                            <td>{info.userId.firstName +" "+ info.userId.lastName}</td>
                            {this.props._id === "bulkImport" && <td>{info.data.count}</td> }
                            <td>{moment(info.date).format('LLLL')}</td>
                        </tr> 
                    )}
                    
                </tbody>
            </table>
            { this.props._id !== "bulkImport" && 
            <div className="col-md-12 text-center">
                <div className="col-md-6">
                    <p className="font-weight-bold">Created By</p><p>{data !== null && data.createdBy !== undefined ? (data.createdBy.firstName +" "+data.createdBy.lastName) : "-" }</p>
                </div>
                <div className="col-md-6"> 
                    <p className="font-weight-bold">Date</p><p>{data !== null ? moment(data.createdBy !== undefined && data.createdAt).format('LLLL') : "-"}</p>
                </div>
            </div>
            }
          </Modal>
          </Fragment>
        )
    }
}

export default Audit;


// WEBPACK FOOTER //
// ./src/components/Common/audit.js